import { jsxs as h, jsx as l } from "react/jsx-runtime";
const v = (a) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M42.023 16.235V6.09H10.022a4 4 0 0 0-4 4v33.674a4 4 0 0 0 4 4H21.94v6.144a4 4 0 0 0 4 4h29.069l-1.071-3.996H30.489l11.532-7.082V20.231h11.917v33.682l3.996-1.071h.002V16.235H42.023ZM25.937 52.16v-4.396h7.537l-7.537 4.396Zm12.089-8.392H10.017V10.086h28.009v33.683-.001Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.743 37.269a10.511 10.511 0 0 0 2.653-.34l-.835-2.89a7.061 7.061 0 0 1-.831.166h-.001a7.152 7.152 0 0 1-.986.067h-.002a7.68 7.68 0 0 1-.725-.035l-.32 2.981c.348.034.698.051 1.044.051h.003ZM22.546 33.823l-2.393-1.95a7.196 7.196 0 0 1-2 1.546l1.529 2.62a10.277 10.277 0 0 0 2.863-2.217l.001.001ZM31.747 20.308c.718-.273 1.48-.462 2.264-.565l-.427-2.969a13.337 13.337 0 0 0-3.448.929l1.28 2.738c.109-.046.222-.091.332-.133h-.001ZM36.224 19.517a10.14 10.14 0 0 1 2.324.258l.74-2.913a13.38 13.38 0 0 0-3.567-.33l.143 2.993c.119-.005.24-.008.36-.009v.001ZM29.843 21.283l-1.793-2.464a12.873 12.873 0 0 0-2.631 2.295h-.001l2.426 1.912a9.778 9.778 0 0 1 1.999-1.743ZM23.91 31.875c.55-1.017.92-2.059 1.237-3.034l-3.01-.887c-.275.844-.59 1.738-1.029 2.549h.001l2.801 1.371v.001ZM11.426 36.942l.643-2.934a7.486 7.486 0 0 1-2.389-.921l-1.676 2.537a10.718 10.718 0 0 0 3.422 1.317v.001ZM26.653 24.757c.056-.105.114-.212.175-.316l-2.758-1.449c-.081.139-.16.282-.234.422-.493.934-.835 1.889-1.079 2.616l3.002.91c.209-.623.499-1.434.894-2.184v.001ZM33.689 33.767l-1.815 1.814-1.815-1.814-1.412 1.412 1.815 1.815-1.815 1.815 1.412 1.413 1.815-1.815 1.815 1.815 1.412-1.413-1.813-1.815 1.813-1.815-1.412-1.412Z"
        }
      )
    ]
  }
);
export {
  v as Map
};
